import { Injectable } from '@angular/core';
import { ApiService, UtilService, PagedSearch, PagedResult } from '../../../shared/index';
import { IEventSponsorsService } from './ievent-sponsor.service';
import { EventSponsor } from './event-sponsor.model';

@Injectable()
export class EventSponsorsService implements IEventSponsorsService {
  public _apiService: ApiService;
  public _utilService: UtilService;

  public constructor(apiService: ApiService, utilService: UtilService) {
    this._apiService = apiService;
    this._utilService = utilService;
  }

  public getEventEventSponsors = (eventId: number): Promise<Array<EventSponsor>> => {
    let url: string = `Event/${eventId}/Sponsors?PageSize=0&PageNumber=0&OrderBy=Sort:asc`;
    return this._apiService.get(url);
  };

  public getEventEventSponsor = (sponsorId: number): Promise<EventSponsor> => {
    return this._apiService.get('EventSponsor/' + sponsorId);
  };

  public upsertEventSponsor = (eventSponsor: EventSponsor): Promise<number> => {
    let url: string = '';
    url = 'EventSponsors/Upsert';
    return this._apiService.post(url, eventSponsor).then(
      (data: number): Promise<number> => {
        return Promise.resolve(data);
      }
    );
  };

  public deleteEventSponsor = (eventSponsorId: number): Promise<void> => {
    let url: string = '';

    url = 'EventSponsor/' + eventSponsorId.toString();
    return this._apiService.delete(url).then(
      (): Promise<void> => {
        return Promise.resolve();
      }
    );
  };

  public reorderEventSponsors = (eventId: number, sponsors: Array<EventSponsor>): Promise<void> => {
    if (!sponsors || !eventId) return Promise.resolve();
    let url = 'Event/' + eventId + '/OrderSponsors';
    let sponsorIds = sponsors
      //.sort((sponsor1, sponsor2) => +sponsor1.Sort - +sponsor2.Sort)
      .map<any>(sponsor => {
        return sponsor.SponserId;
      });

    return this._apiService.post(url, sponsorIds).then(
      (): Promise<void> => {
        return Promise.resolve();
      }
    );
  };
}
